var _clipPath, _clipPath2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSouthAfrica = function SvgSouthAfrica(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    viewBox: "0 0 9 6",
    ref: ref
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 4.5,3 0,6",
    id: "X"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H9V6H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V6H9V0z",
    fill: "#002395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V3H9V0z",
    fill: "#de3831"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 4.5,3 0,6M4.5,3H9",
    id: "W"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    stroke: "#ffb612",
    clipPath: "url(#Z)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W",
    fill: "none",
    stroke: "#007a4d",
    strokeWidth: 1.2
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSouthAfrica);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjkwMCIgaGVpZ2h0PSI2MDAiIHZpZXdCb3g9IjAgMCA5IDYiPgo8Y2xpcFBhdGggaWQ9IloiPgo8cGF0aCBkPSJNMCwwIDQuNSwzIDAsNiIgaWQ9IlgiLz4KPC9jbGlwUGF0aD4KPGNsaXBQYXRoIGlkPSJBIj4KPHBhdGggZD0iTTAsMEg5VjZIMHoiLz4KPC9jbGlwUGF0aD4KPGcgY2xpcC1wYXRoPSJ1cmwoI0EpIj4KPHBhdGggZD0iTTAsMFY2SDlWMHoiIGZpbGw9IiMwMDIzOTUiLz4KPHBhdGggZD0iTTAsMFYzSDlWMHoiIGZpbGw9IiNkZTM4MzEiLz4KPGcgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiNmZmYiPgo8cGF0aCBkPSJNMCwwIDQuNSwzIDAsNk00LjUsM0g5IiBpZD0iVyIvPgo8dXNlIHhsaW5rOmhyZWY9IiNYIiBzdHJva2U9IiNmZmI2MTIiIGNsaXAtcGF0aD0idXJsKCNaKSIvPgo8L2c+Cjx1c2UgeGxpbms6aHJlZj0iI1ciIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwN2E0ZCIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPC9nPgo8L3N2Zz4=";